<rs-web-side-sheet-form
  #sideSheetForm="rsWebSideSheetForm"
  [doneButtonText]="'submit_l' | translate"
  [loading]="changeRequestActionState().pending"
  [showBackButton]="true"
  [showNav]="false"
  [formGroup]="form"
  (dismiss)="$event.dismiss()"
>
  <span class="sidesheet-title" sidesheet-title>
    {{ 'user_payment_edit.form_h' | translate }}
  </span>

  <ng-template
    [currentStepValid]="form.valid"
    [customDoneButtonText]="'next'"
    [label]="'Selection'"
    (next)="sideSheetForm.nextTab()"
    rsWebSideSheetContent
  >
    <im-form-field class="mb-3">
      <label class="im:floating-label">
        <span floatingLabel>{{ 'user_payment_edit.form_iban_l' | translate }}</span>
        <input
          class="im:input"
          formControlName="iban"
          id="iban"
          type="text"
          [placeholder]="'user_payment_edit.form_iban_l' | translate"
        />
      </label>
    </im-form-field>

    <im-form-field class="mb-3">
      <label class="im:floating-label">
        <span floatingLabel>{{ 'user_payment_edit.form_account_holder_l' | translate }}</span>
        <input
          class="im:input"
          formControlName="accountOwner"
          id="accountOwner"
          type="text"
          [placeholder]="'user_payment_edit.form_account_holder_l' | translate"
        />
      </label>
    </im-form-field>

    <im-form-field class="mb-3">
      <rs-web-date-picker
        [minDate]="minDate"
        formControlName="issuedAt"
        id="issuedAt"
        label="user_payment_edit.form_issued_at_l"
      />
    </im-form-field>

    <p class="mb-3">
      {{ 'user_payment_edit.form_sepa_text_l' | translate }}
    </p>

    <div class="slider">
      <input
        slide-toggle
        formControlName="hasAcceptedSepaMandate"
        id="hasAcceptedSepaMandate"
        type="checkbox"
        class="mr-3"
      />

      <label class="form-label" for="hasAcceptedSepaMandate"
        >{{ 'user_payment_edit.form_direct_debit_concent_toggle_start' | translate }}
        <a im-button (click)="openNotice()">
          {{ 'user_payment_edit.form_direct_debit_concent_toggle_link' | translate }}
        </a>
        {{ 'user_payment_edit.form_direct_debit_concent_toggle_end' | translate }}</label
      >
    </div>

    <div class="slider">
      <input slide-toggle id="test" type="checkbox" (click)="allContractsSelectedToggle()" />

      <label class="form-label" for="test"
        >{{ 'user_payment_edit.form_save_new_payment_toggle_l' | translate }}
      </label>
    </div>

    @if (!this.allContractsSelected()) {
      <rs-web-multi-select-dropdown-v2
        itemValueKey="id"
        [items]="contractSelections()"
        [useValue]="true"
        formControlName="selectedContracts"
      >
        <ng-template let-item> {{ item.text }}</ng-template>
      </rs-web-multi-select-dropdown-v2>
    }
  </ng-template>

  <ng-template (done)="sendRequest()" rsWebSideSheetContent>
    <rs-web-user-profile-edit-summary [changeType]="MasterDataChangeType.PAYMENT">
      <ng-container custom>
        <div class="mt-2 secondary-text">
          {{ 'user_payment_edit.form_iban_l' | translate }}
        </div>
        <div>
          {{ form.value.iban }}
        </div>
        <div class="mt-2 secondary-text">
          {{ 'user_payment_edit.form_account_holder_l' | translate }}
        </div>
        <div>
          {{ form.value.accountOwner }}
        </div>
        <div class="mt-2 secondary-text">
          {{ 'user_payment_edit.form_issued_at_l' | translate }}
        </div>
        <div>
          {{ form.value.issuedAt | date: 'dd.MM.yyyy' }}
        </div>
        <div class="mt-2 secondary-text">
          {{ 'user_payment_edit.form_contracts_l' | translate }}
        </div>
        @for (contract of form.controls.selectedContracts.value; track contract.id) {
          <div>
            {{ contract.text }}
          </div>
        }
      </ng-container>
    </rs-web-user-profile-edit-summary>
  </ng-template>
</rs-web-side-sheet-form>
